import React from 'react';
import Icon from '../../../components/AppIcon';

const TransactionHistory = ({ transactions }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return {
      date: date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
      }),
      time: date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit'
      })
    };
  };

  const getTransactionIcon = (type) => {
    return type === 'add' ? 'Plus' : 'Minus';
  };

  const getTransactionColor = (type) => {
    return type === 'add' ?'text-success bg-success/10 border-success/20' :'text-warning bg-warning/10 border-warning/20';
  };

  if (!transactions || transactions.length === 0) {
    return (
      <div className="bg-card border border-border rounded-lg shadow-sm overflow-hidden">
        <div className="px-6 py-4 bg-muted/20 border-b border-border">
          <h3 className="text-lg font-semibold text-foreground flex items-center space-x-2">
            <Icon name="History" size={18} />
            <span>Transaction History</span>
          </h3>
        </div>
        <div className="p-6 text-center">
          <Icon name="Clock" size={48} className="mx-auto text-muted-foreground mb-3" />
          <p className="text-muted-foreground">No transactions yet</p>
          <p className="text-sm text-muted-foreground/70 mt-1">
            Transaction history will appear here
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg shadow-sm overflow-hidden">
      {/* Header */}
      <div className="px-6 py-4 bg-muted/20 border-b border-border">
        <h3 className="text-lg font-semibold text-foreground flex items-center space-x-2">
          <Icon name="History" size={18} />
          <span>Transaction History</span>
        </h3>
        <p className="text-sm text-muted-foreground mt-1">
          Recent account activity
        </p>
      </div>

      {/* Transaction List */}
      <div className="divide-y divide-border">
        {transactions.map((transaction) => {
          const formattedDate = formatDate(transaction.date);
          const transactionColor = getTransactionColor(transaction.type);
          // Treat as a session transaction only when there is a positive sessions value.
          const isSessionTx =
            typeof transaction.sessions === 'number' &&
            !isNaN(transaction.sessions) &&
            transaction.sessions > 0;
          const value = isSessionTx ? transaction.sessions : transaction.amount;
          const unitLabel = isSessionTx ? 'sessions' : 'minutes';

          return (
            <div key={transaction.id} className="p-4 hover:bg-muted/30 transition-colors">
              <div className="flex items-start justify-between">
                {/* Left Side - Icon and Details */}
                <div className="flex items-start space-x-3 flex-1">
                  <div className={`p-2 rounded-full border ${transactionColor}`}>
                    <Icon 
                      name={getTransactionIcon(transaction.type)} 
                      size={16} 
                    />
                  </div>
                  
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center space-x-2 mb-1">
                      <span className={`text-lg font-semibold font-mono ${
                        transaction.type === 'add' ? 'text-success' : 'text-warning'
                      }`}>
                        {transaction.type === 'add' ? '+' : '-'}{value}
                      </span>
                      <span className="text-sm text-muted-foreground">{unitLabel}</span>
                    </div>
                    
                    <p className="text-sm text-foreground mb-1 truncate">
                      {transaction.description}
                    </p>
                    
                    <div className="flex items-center space-x-3 text-xs text-muted-foreground">
                      <div className="flex items-center space-x-1">
                        <Icon name="User" size={12} />
                        <span>{transaction.staff}</span>
                      </div>
                      <div className="flex items-center space-x-1">
                        <Icon name="Calendar" size={12} />
                        <span>{formattedDate.date}</span>
                      </div>
                      <div className="flex items-center space-x-1">
                        <Icon name="Clock" size={12} />
                        <span>{formattedDate.time}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Footer */}
      <div className="px-6 py-3 bg-muted/10 border-t border-border">
        <div className="flex items-center justify-between text-xs text-muted-foreground">
          <span>Showing {transactions.length} recent transaction{transactions.length !== 1 ? 's' : ''}</span>
          <span>Updated: {new Date().toLocaleTimeString()}</span>
        </div>
      </div>
    </div>
  );
};

export default TransactionHistory;